import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { Checkbox as MUICheckbox } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { InfoCircle } from './InfoCircle';

const GlobalStyle = createGlobalStyle`
  .form-control {
    .MuiInputBase-root {
      font-family: 'Whitney Book';
    }
  }
  .PrivateRadioButtonIcon-layer-6 {
    color: #006C9C;
  }
  .MuiIconButton-label {
    padding-left: 3px;
  }

  &&&&& .MuiCheckbox-root, .MuiCheckbox-colorPrimary {
    &:hover {
      background-color: transparent;
    }
  }

  .icon-box {
    border: 1px solid #888888;
    width: 20px;
    height: 20px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-top: -9px;
    input:hover, input:focus-visible ~ & {
      outline: 2px solid #106ba3;
    }

    &.checked-icon {
      border: 1px solid #006C9C;
    }
  }

  .checked-icon: {

    background-color: #006C9C;
    &:before {
      display: block;
      width: 18px;
      height: 18px;
      background-color: #006C9C;
      border: 4px solid #fff;
      content: ""
    }
    input:hover ~ & {
      background-color: #106ba3
    }
  }

  .fix-margin-on-checkbox {
    align-items: flex-start;
    margin-left: -9px;

    &:hover {
      background-color: inherit;
      .icon-box {
        border: 1px solid #006C9C;
      }
    }
  }
  /* Shared row wrapper to align checkbox rows consistently across the app */
  .check-row {
    display: flex;
    align-items: flex-start;
    gap: 12px;
  }
  .check-row .MuiFormControlLabel-root {
    align-items: flex-start;
  }
  .check-row input[type="checkbox"] {
    margin-top: 2px;
  }
  .check-row .MuiTypography-root.MuiFormControlLabel-label.MuiTypography-body1 {
    line-height: 1.4;
  }
  .MuiTypography-root.MuiFormControlLabel-label.MuiTypography-body1 {
    font-family: 'Whitney Medium';
    color: #272727;
  }
  .MuiTypography-root.MuiFormControlLabel-label.Mui-disabled.MuiTypography-body1{
    color: #888888;
  }
`;

export function Checkbox({
  name,
  label,
  value = false,
  color,
  id,
  labelPlacement,
  disabled,
  onChange = () => {},
  infoText,
}) {
  return (
    <>
      <GlobalStyle />
      <FormControl variant="outlined">
        <FormControlLabel
          value={value}
          disabled={disabled}
          classes={{ root: 'fix-margin-on-checkbox' }}
          control={
            <MUICheckbox
              name={name}
              color={color}
              id={id}
              checked={value}
              onChange={onChange}
              checkedIcon={<span className="icon-box checked-icon" />}
              icon={<span className="icon-box" />}
              inputProps={{ 'aria-label': 'decorative checkbox' }}
            />
          }
          label={
            <>
              {label}
              {infoText && <InfoCircle text={infoText} clickable />}
            </>
          }
          labelPlacement={labelPlacement}
          htmlFor={id}
        />
      </FormControl>
    </>
  );
}
